import { html } from 'lit';

// database icon

export const DatabaseSearchIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 3.75C6.99594 3.75 3.75 6.99594 3.75 11C3.75 15.0041 6.99594 18.25 11 18.25C13.0026 18.25 14.8156 17.4381 16.1276 16.1254L16.1287 16.1243C17.4393 14.8125 18.25 13.0008 18.25 11C18.25 6.99594 15.0041 3.75 11 3.75ZM17.6965 16.6324C18.9779 15.1104 19.75 13.1453 19.75 11C19.75 6.16751 15.8325 2.25 11 2.25C6.16751 2.25 2.25 6.16751 2.25 11C2.25 15.8325 6.16751 19.75 11 19.75C13.1471 19.75 15.1136 18.9767 16.6361 17.6933L20.4694 21.5301C20.7622 21.8231 21.2371 21.8233 21.5301 21.5306C21.8231 21.2378 21.8233 20.7629 21.5306 20.4699L17.6965 16.6324Z"
  />
</svg>`;

export const DatabasePen = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 6.20314L5.5 15L4 20L9 18.5L17.7969 10M14 6.20314L15.3595 4.79619C16.4211 3.73461 18.1422 3.7346 19.2038 4.79619C20.2654 5.85777 20.2654 7.57894 19.2038 8.64052L17.7969 10M14 6.20314L17.7969 10"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseDelete = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseDuplicate = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.25 9C11.25 9.41421 11.5858 9.75 12 9.75H13.1893L7.46967 15.4697C7.17678 15.7626 7.17678 16.2374 7.46967 16.5303C7.76256 16.8232 8.23744 16.8232 8.53033 16.5303L14.25 10.8107V12C14.25 12.4142 14.5858 12.75 15 12.75C15.4142 12.75 15.75 12.4142 15.75 12V9.1C15.75 9.08264 15.7495 9.0654 15.7485 9.04829C15.7618 8.84059 15.6891 8.62841 15.5303 8.46967C15.3716 8.31093 15.1594 8.23823 14.9517 8.25155C14.9346 8.25052 14.9174 8.25 14.9 8.25H12C11.5858 8.25 11.25 8.58579 11.25 9Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.8304 3.25H11.1696C10.6354 3.24999 10.1896 3.24998 9.82533 3.27974C9.44545 3.31078 9.08879 3.37789 8.75153 3.54973C8.23408 3.81338 7.81339 4.23408 7.54973 4.75153C7.37789 5.08879 7.31078 5.44545 7.27974 5.82533C7.24998 6.18956 7.24999 6.63541 7.25 7.16956L7.25 7.25L7.16957 7.25C6.63542 7.24999 6.18956 7.24998 5.82533 7.27974C5.44545 7.31078 5.08879 7.37789 4.75153 7.54973C4.23408 7.81339 3.81338 8.23408 3.54973 8.75153C3.37789 9.08879 3.31078 9.44545 3.27974 9.82533C3.24998 10.1896 3.24999 10.6354 3.25 11.1696V16.8304C3.24999 17.3646 3.24998 17.8104 3.27974 18.1747C3.31078 18.5546 3.37789 18.9112 3.54973 19.2485C3.81338 19.7659 4.23408 20.1866 4.75153 20.4503C5.08879 20.6221 5.44545 20.6892 5.82533 20.7203C6.18956 20.75 6.6354 20.75 7.16955 20.75H12.8305C13.3646 20.75 13.8104 20.75 14.1747 20.7203C14.5546 20.6892 14.9112 20.6221 15.2485 20.4503C15.7659 20.1866 16.1866 19.7659 16.4503 19.2485C16.6221 18.9112 16.6892 18.5546 16.7203 18.1747C16.75 17.8105 16.75 17.3646 16.75 16.8305V16.75H16.8305C17.3646 16.75 17.8105 16.75 18.1747 16.7203C18.5546 16.6892 18.9112 16.6221 19.2485 16.4503C19.7659 16.1866 20.1866 15.7659 20.4503 15.2485C20.6221 14.9112 20.6892 14.5546 20.7203 14.1747C20.75 13.8104 20.75 13.3646 20.75 12.8305V7.16955C20.75 6.6354 20.75 6.18956 20.7203 5.82533C20.6892 5.44545 20.6221 5.08879 20.4503 4.75153C20.1866 4.23408 19.7659 3.81338 19.2485 3.54973C18.9112 3.37789 18.5546 3.31078 18.1747 3.27974C17.8104 3.24998 17.3646 3.24999 16.8304 3.25ZM7.25 11V8.75H7.2C6.62757 8.75 6.24336 8.75058 5.94748 8.77476C5.66036 8.79822 5.52307 8.8401 5.43251 8.88624C5.19731 9.00608 5.00608 9.19731 4.88624 9.43251C4.8401 9.52307 4.79822 9.66036 4.77476 9.94748C4.75058 10.2434 4.75 10.6276 4.75 11.2V16.8C4.75 17.3724 4.75058 17.7566 4.77476 18.0525C4.79822 18.3396 4.8401 18.4769 4.88624 18.5675C5.00608 18.8027 5.19731 18.9939 5.43251 19.1138C5.52307 19.1599 5.66036 19.2018 5.94748 19.2252C6.24336 19.2494 6.62757 19.25 7.2 19.25H12.8C13.3724 19.25 13.7566 19.2494 14.0525 19.2252C14.3396 19.2018 14.4769 19.1599 14.5675 19.1138C14.8027 18.9939 14.9939 18.8027 15.1138 18.5675C15.1599 18.4769 15.2018 18.3396 15.2252 18.0525C15.2494 17.7566 15.25 17.3724 15.25 16.8V16.75H13C12.5858 16.75 12.25 16.4142 12.25 16C12.25 15.5858 12.5858 15.25 13 15.25H16.8C17.3724 15.25 17.7566 15.2494 18.0525 15.2252C18.3396 15.2018 18.4769 15.1599 18.5675 15.1138C18.8027 14.9939 18.9939 14.8027 19.1138 14.5675C19.1599 14.4769 19.2018 14.3396 19.2252 14.0525C19.2494 13.7566 19.25 13.3724 19.25 12.8V7.2C19.25 6.62757 19.2494 6.24336 19.2252 5.94748C19.2018 5.66036 19.1599 5.52307 19.1138 5.43251C18.9939 5.19731 18.8027 5.00608 18.5675 4.88624C18.4769 4.8401 18.3396 4.79822 18.0525 4.77476C17.7566 4.75058 17.3724 4.75 16.8 4.75H11.2C10.6276 4.75 10.2434 4.75058 9.94748 4.77476C9.66036 4.79822 9.52307 4.8401 9.43251 4.88624C9.19731 5.00608 9.00608 5.19731 8.88624 5.43251C8.8401 5.52307 8.79822 5.66036 8.77476 5.94748C8.75058 6.24336 8.75 6.62757 8.75 7.2V11C8.75 11.4142 8.41422 11.75 8 11.75C7.58579 11.75 7.25 11.4142 7.25 11Z"
  />
</svg>`;

export const DatabaseInsertLeft = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.25 6C12.25 4.48122 13.4812 3.25 15 3.25H18C19.5188 3.25 20.75 4.48122 20.75 6V18C20.75 19.5188 19.5188 20.75 18 20.75H15C13.4812 20.75 12.25 19.5188 12.25 18V6ZM15 4.75C14.3096 4.75 13.75 5.30964 13.75 6V18C13.75 18.6904 14.3096 19.25 15 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V6C19.25 5.30964 18.6904 4.75 18 4.75H15Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25L10 11.25C10.4142 11.25 10.75 11.5858 10.75 12C10.75 12.4142 10.4142 12.75 10 12.75L4 12.75C3.58579 12.75 3.25 12.4142 3.25 12Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 15.75C6.58579 15.75 6.25 15.4142 6.25 15L6.25 9C6.25 8.58579 6.58579 8.25 7 8.25C7.41421 8.25 7.75 8.58579 7.75 9L7.75 15C7.75 15.4142 7.41421 15.75 7 15.75Z"
  />
</svg>`;

export const DatabaseInsertRight = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.75 6C11.75 4.48122 10.5188 3.25 9 3.25H6C4.48122 3.25 3.25 4.48122 3.25 6V18C3.25 19.5188 4.48122 20.75 6 20.75H9C10.5188 20.75 11.75 19.5188 11.75 18V6ZM9 4.75C9.69036 4.75 10.25 5.30964 10.25 6V18C10.25 18.6904 9.69036 19.25 9 19.25H6C5.30964 19.25 4.75 18.6904 4.75 18V6C4.75 5.30964 5.30964 4.75 6 4.75H9Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.75 12C20.75 11.5858 20.4142 11.25 20 11.25L14 11.25C13.5858 11.25 13.25 11.5858 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75L20 12.75C20.4142 12.75 20.75 12.4142 20.75 12Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 15.75C17.4142 15.75 17.75 15.4142 17.75 15V9C17.75 8.58579 17.4142 8.25 17 8.25C16.5858 8.25 16.25 8.58579 16.25 9V15C16.25 15.4142 16.5858 15.75 17 15.75Z"
  />
</svg>`;

export const DatabaseMoveLeft = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 4V20M8 12H20M8 12L12 8M8 12L12 16"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseMoveRight = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20 4V20M4 12H16M16 12L12 8M16 12L12 16"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const DatabaseMultiSelect = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 5L6.42929 7.42929C6.46834 7.46834 6.53166 7.46834 6.57071 7.42929L9 5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M4 11L6.42929 13.4293C6.46834 13.4683 6.53166 13.4683 6.57071 13.4293L9 11"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M4 17L6.42929 19.4293C6.46834 19.4683 6.53166 19.4683 6.57071 19.4293L9 17"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 6L20 6"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 12L20 12"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 18L20 18"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

export const DatabaseNumber = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M18.5 4L12.5 20"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M12 4L6 20"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M20 8.5H5.5"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M19 15L4 15"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>`;

export const DatabaseSelect = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.46967 10.4697C7.76256 10.1768 8.23744 10.1768 8.53033 10.4697L12 13.9393L15.4697 10.4697C15.7626 10.1768 16.2374 10.1768 16.5303 10.4697C16.8232 10.7626 16.8232 11.2374 16.5303 11.5303L12.601 15.4596C12.2691 15.7916 11.7309 15.7916 11.399 15.4596L7.46967 11.5303C7.17678 11.2374 7.17678 10.7626 7.46967 10.4697Z"
  />
</svg>`;

export const DatabaseProgress = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 4.25C15.4142 4.25 15.75 4.58579 15.75 5V6.25H18C20.0711 6.25 21.75 7.92893 21.75 10V14C21.75 16.0711 20.0711 17.75 18 17.75H15.75V19C15.75 19.4142 15.4142 19.75 15 19.75C14.5858 19.75 14.25 19.4142 14.25 19V17.75H6C3.92893 17.75 2.25 16.0711 2.25 14V10C2.25 7.92893 3.92893 6.25 6 6.25H14.25V5C14.25 4.58579 14.5858 4.25 15 4.25ZM14.25 7.75H6C4.75736 7.75 3.75 8.75736 3.75 10V14C3.75 15.2426 4.75736 16.25 6 16.25H14.25V7.75ZM15.75 16.25H18C19.2426 16.25 20.25 15.2426 20.25 14V10C20.25 8.75736 19.2426 7.75 18 7.75H15.75V16.25ZM6 9.25C6.41421 9.25 6.75 9.58579 6.75 10V14C6.75 14.4142 6.41421 14.75 6 14.75C5.58579 14.75 5.25 14.4142 5.25 14L5.25 10C5.25 9.58579 5.58579 9.25 6 9.25ZM9 9.25C9.41421 9.25 9.75 9.58579 9.75 10L9.75 14C9.75 14.4142 9.41421 14.75 9 14.75C8.58579 14.75 8.25 14.4142 8.25 14L8.25 10C8.25 9.58579 8.58579 9.25 9 9.25ZM12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V14C12.75 14.4142 12.4142 14.75 12 14.75C11.5858 14.75 11.25 14.4142 11.25 14V10C11.25 9.58579 11.5858 9.25 12 9.25Z"
  />
</svg>`;

export const DatabaseSearchClose = html`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.22872 4.22878C4.42398 4.03352 4.74057 4.03352 4.93583 4.22878L7.99996 7.29291L11.0641 4.22878C11.2593 4.03352 11.5759 4.03352 11.7712 4.22878C11.9665 4.42405 11.9665 4.74063 11.7712 4.93589L8.70707 8.00002L11.7712 11.0641C11.9665 11.2594 11.9665 11.576 11.7712 11.7713C11.5759 11.9665 11.2593 11.9665 11.0641 11.7713L7.99996 8.70713L4.93583 11.7713C4.74057 11.9665 4.42398 11.9665 4.22872 11.7713C4.03346 11.576 4.03346 11.2594 4.22872 11.0641L7.29285 8.00002L4.22872 4.93589C4.03346 4.74063 4.03346 4.42405 4.22872 4.22878Z"
  />
</svg>`;

export const DatabaseDone = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.5322 5.97152C20.824 6.26543 20.8224 6.7403 20.5285 7.03217L9.45156 18.0322C9.15909 18.3226 8.68706 18.3226 8.3946 18.0322L3.47152 13.1433C3.17761 12.8514 3.17595 12.3765 3.46783 12.0826C3.7597 11.7887 4.23457 11.7871 4.52848 12.0789L8.92308 16.443L19.4715 5.96783C19.7654 5.67595 20.2403 5.67761 20.5322 5.97152Z"
  />
</svg>`;

const addColumnStyle = `
  width: 12px;
  height: 12px;
  fill: var(--affine-text-primary-color);
`;
export const DatabaseAddColumn = html`<svg
  viewBox="0 0 16 16"
  style=${addColumnStyle}
>
  <path
    d="M7.977 14.963c.407 0 .747-.324.747-.723V8.72h5.362c.399 0 .74-.34.74-.747a.746.746 0 00-.74-.738H8.724V1.706c0-.398-.34-.722-.747-.722a.732.732 0 00-.739.722v5.529h-5.37a.746.746 0 00-.74.738c0 .407.341.747.74.747h5.37v5.52c0 .399.332.723.739.723z"
  ></path>
</svg>`;

export const DatabaseDragIcon = html`<svg
  width="10"
  height="14"
  viewBox="0 0 10 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="10" height="14" rx="2" />
  <rect width="10" height="14" rx="2" fill-opacity="0.08" />
  <g clip-path="url(#clip0_179_9218)">
    <circle cx="3" cy="3" r="1" fill="var(--affine-icon-color)" />
    <circle cx="3" cy="6.79163" r="1" fill="var(--affine-icon-color)" />
    <circle cx="3" cy="10.5833" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="3" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="6.79163" r="1" fill="var(--affine-icon-color)" />
    <circle cx="7" cy="10.5833" r="1" fill="var(--affine-icon-color)" />
  </g>
  <defs>
    <clipPath id="clip0_179_9218">
      <rect width="6" height="10" transform="translate(2 2)" />
    </clipPath>
  </defs>
</svg>`;

export const DatabaseSelectionColor = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C13.2426 20.25 14.25 19.2426 14.25 18V17.4C14.25 17.3802 14.25 17.3606 14.25 17.3414C14.2499 17.0272 14.2498 16.7851 14.2839 16.5698C14.4702 15.3931 15.3931 14.4702 16.5698 14.2839C16.7851 14.2498 17.0272 14.2499 17.3414 14.25C17.3606 14.25 17.3802 14.25 17.4 14.25H18C19.2426 14.25 20.25 13.2426 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 14.0711 20.0711 15.75 18 15.75H17.4C16.9997 15.75 16.8869 15.7523 16.8045 15.7654C16.2696 15.8501 15.8501 16.2696 15.7654 16.8045C15.7523 16.8869 15.75 16.9997 15.75 17.4V18C15.75 20.0711 14.0711 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM9.25 7.5C9.25 6.80964 9.80964 6.25 10.5 6.25C11.1904 6.25 11.75 6.80964 11.75 7.5C11.75 8.19036 11.1904 8.75 10.5 8.75C9.80964 8.75 9.25 8.19035 9.25 7.5ZM14.25 8.5C14.25 7.80964 14.8096 7.25 15.5 7.25C16.1904 7.25 16.75 7.80964 16.75 8.5C16.75 9.19035 16.1904 9.75 15.5 9.75C14.8096 9.75 14.25 9.19035 14.25 8.5ZM6.25 11.5C6.25 10.8096 6.80964 10.25 7.5 10.25C8.19035 10.25 8.75 10.8096 8.75 11.5C8.75 12.1904 8.19035 12.75 7.5 12.75C6.80964 12.75 6.25 12.1904 6.25 11.5Z"
    />
  </svg>
`;

export const DatabaseExpandWide = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.75 5.75L8 5.75C8.41421 5.75 8.75 5.41421 8.75 5C8.75 4.58579 8.41421 4.25 8 4.25L3 4.25C2.58579 4.25 2.25 4.58579 2.25 5V10C2.25 10.4142 2.58579 10.75 3 10.75C3.41421 10.75 3.75 10.4142 3.75 10V5.75ZM15.25 5C15.25 4.58579 15.5858 4.25 16 4.25H21C21.4142 4.25 21.75 4.58579 21.75 5V10C21.75 10.4142 21.4142 10.75 21 10.75C20.5858 10.75 20.25 10.4142 20.25 10V5.75H16C15.5858 5.75 15.25 5.41421 15.25 5ZM3 13.25C3.41421 13.25 3.75 13.5858 3.75 14V18.25L8 18.25C8.41421 18.25 8.75 18.5858 8.75 19C8.75 19.4142 8.41421 19.75 8 19.75L3 19.75C2.58579 19.75 2.25 19.4142 2.25 19V14C2.25 13.5858 2.58579 13.25 3 13.25ZM21 13.25C21.4142 13.25 21.75 13.5858 21.75 14V19C21.75 19.4142 21.4142 19.75 21 19.75H16C15.5858 19.75 15.25 19.4142 15.25 19C15.25 18.5858 15.5858 18.25 16 18.25H20.25V14C20.25 13.5858 20.5858 13.25 21 13.25Z"
    />
  </svg>
`;

export const DatabaseExpand = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4697 3.46967C11.7626 3.17678 12.2374 3.17678 12.5303 3.46967L17.5303 8.46967C17.8232 8.76256 17.8232 9.23744 17.5303 9.53033C17.2374 9.82322 16.7626 9.82322 16.4697 9.53033L12 5.06066L7.53033 9.53033C7.23744 9.82322 6.76256 9.82322 6.46967 9.53033C6.17678 9.23744 6.17678 8.76256 6.46967 8.46967L11.4697 3.46967ZM6.46967 14.4697C6.76256 14.1768 7.23744 14.1768 7.53033 14.4697L12 18.9393L16.4697 14.4697C16.7626 14.1768 17.2374 14.1768 17.5303 14.4697C17.8232 14.7626 17.8232 15.2374 17.5303 15.5303L12.5303 20.5303C12.2374 20.8232 11.7626 20.8232 11.4697 20.5303L6.46967 15.5303C6.17678 15.2374 6.17678 14.7626 6.46967 14.4697Z"
    />
  </svg>
`;

export const DatabaseCompress = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 4.25C8.41421 4.25 8.75 4.58579 8.75 5V10C8.75 10.4142 8.41421 10.75 8 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H7.25V5C7.25 4.58579 7.58579 4.25 8 4.25ZM16 4.25C16.4142 4.25 16.75 4.58579 16.75 5V9.25H21C21.4142 9.25 21.75 9.58579 21.75 10C21.75 10.4142 21.4142 10.75 21 10.75H16C15.5858 10.75 15.25 10.4142 15.25 10V5C15.25 4.58579 15.5858 4.25 16 4.25ZM2.25 14C2.25 13.5858 2.58579 13.25 3 13.25H8C8.41421 13.25 8.75 13.5858 8.75 14V19C8.75 19.4142 8.41421 19.75 8 19.75C7.58579 19.75 7.25 19.4142 7.25 19V14.75H3C2.58579 14.75 2.25 14.4142 2.25 14ZM15.25 14C15.25 13.5858 15.5858 13.25 16 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14C21.75 14.4142 21.4142 14.75 21 14.75H16.75V19C16.75 19.4142 16.4142 19.75 16 19.75C15.5858 19.75 15.25 19.4142 15.25 19V14Z"
      fill="#77757D"
    />
  </svg>
`;

export const DatabaseTableViewClose = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.34314 6.34321C6.63604 6.05031 7.11091 6.05031 7.4038 6.34321L12 10.9394L16.5962 6.34321C16.8891 6.05031 17.364 6.05031 17.6569 6.34321C17.9497 6.6361 17.9497 7.11097 17.6569 7.40387L13.0607 12.0001L17.6569 16.5963C17.9497 16.8891 17.9497 17.364 17.6569 17.6569C17.364 17.9498 16.8891 17.9498 16.5962 17.6569L12 13.0607L7.4038 17.6569C7.11091 17.9498 6.63604 17.9498 6.34314 17.6569C6.05025 17.364 6.05025 16.8891 6.34314 16.5963L10.9393 12.0001L6.34314 7.40387C6.05025 7.11097 6.05025 6.6361 6.34314 6.34321Z"
    />
  </svg>
`;
